













































































































































import Vue from 'vue';
import axios from 'axios';
import ConfirmDelete from '../components/ConfirmDelete.vue';

declare const window: any;

export default Vue.extend({
    name: 'Payment',
    components: {
        ConfirmDelete: ConfirmDelete
    },
    data() {
        return {
            disableButton: false,
            errorMsg: '',
            showErrorMsg: false,
            cardError: '',
            phoneInput: '',
            paymentMessage: '',
            isValid: true,
            showConfirmDelete: false,
            showUpdateCard: false,
            step: 'loading',
            hasSubscription: false,
            selectedTier: 1,
            publishableKey: '',
            testMode: false,
            stripeInstance: null as any,
            cardElement: null as any,
            invoices: [] as any[],
            invoicesLoading: false,
            invoicesError: false,
            showAllInvoices: false
        }
    },
    computed: {
        visibleInvoices(): any[] {
            return this.showAllInvoices ? this.invoices : this.invoices.slice(0, 5);
        }
    },
    async created() {
        await axios.get(this.$store.state.apiUrl + '/payment/status')
            .then(resp => {
                this.publishableKey = resp.data.publishableKey;
                this.testMode = !!resp.data.testMode;
                // A subscription that's canceled/unpaid/expired isn't a real
                // subscription to "update" anymore - treat it the same as
                // never having subscribed, and offer the tier cards again.
                // past_due still has an active grace period, so that one
                // stays on the update-card form to fix the payment method.
                const noActiveSubscription = ['NONE', 'canceled', 'unpaid', 'incomplete_expired'].includes(resp.data.status);
                if(noActiveSubscription) {
                    this.hasSubscription = false;
                    this.step = 'tiers';
                } else {
                    this.hasSubscription = true;
                    this.step = 'form';
                    if(resp.data.status !== 'active' && resp.data.status !== 'trialing') {
                        this.isValid = false;
                    }
                    this.paymentMessage = resp.data.status;
                }
            })
            .catch(e => {
                this.isValid = false;
                this.paymentMessage = e.response ? e.response.data : 'There was an error loading your payment status.';
                this.hasSubscription = true;
                this.step = 'form';
            });
        if(this.hasSubscription) {
            this.loadInvoices();
        }
        this.$store.state.routeLoaded = true;
        // For an existing subscriber the card form is now hidden behind
        // "Update your payment method" - only auto-mount it for a fresh
        // signup, where the form is shown immediately.
        if(this.step === 'form' && !this.hasSubscription) {
            this.$nextTick(() => this.setupCardElement());
        }
    },
    beforeDestroy() {
        if(this.cardElement) {
            this.cardElement.destroy();
        }
    },
    methods: {
        selectTier(tier: number) {
            this.selectedTier = tier;
            this.step = 'form';
            this.$nextTick(() => this.setupCardElement());
        },
        backToTiers() {
            if(this.cardElement) {
                this.cardElement.destroy();
                this.cardElement = null;
            }
            this.step = 'tiers';
        },
        loadStripeJs() {
            return new Promise((resolve, reject) => {
                if(window.Stripe) {
                    resolve(window.Stripe);
                    return;
                }
                const script = document.createElement('script');
                script.src = 'https://js.stripe.com/v3/';
                script.onload = () => resolve(window.Stripe);
                script.onerror = reject;
                document.head.appendChild(script);
            });
        },
        async setupCardElement() {
            await this.loadStripeJs();
            if(!this.stripeInstance) {
                this.stripeInstance = window.Stripe(this.publishableKey);
            }
            if(this.cardElement) {
                this.cardElement.destroy();
            }
            const elements = this.stripeInstance.elements();
            this.cardElement = elements.create('card', {
                style: {
                    base: {
                        fontSize: '16px',
                        fontFamily: '"Montserrat", sans-serif',
                        color: '#5c5c5c',
                        '::placeholder': { color: '#999' }
                    }
                }
            });
            this.cardElement.mount(this.$refs.cardElementMount);
            this.cardElement.on('change', (event: any) => {
                this.cardError = event.error ? event.error.message : '';
            });
        },
        async submit() {
            if(this.disableButton) {
                return;
            }
            this.disableButton = true;
            const data = {
                email: (this.$refs.email as HTMLInputElement).value,
                firstName: (this.$refs.firstName as HTMLInputElement).value,
                lastName: (this.$refs.lastName as HTMLInputElement).value,
                phone: this.phoneInput.replace(/()-/g, ''),
                address: (this.$refs.address as HTMLInputElement).value,
                city: (this.$refs.city as HTMLInputElement).value,
                state: (this.$refs.state as HTMLInputElement).value,
                zip: (this.$refs.zip as HTMLInputElement).value,
                tier: this.selectedTier,
                hsPortalId: this.$store.state.portalId
            };
            let isError = false;
            Object.keys(data).forEach(key => {
                if(key == 'hsPortalId' || key == "phone" || key == "tier") return;
                if(!(data as any)[key] && this.$refs[key]) {
                    isError = true;
                    (this.$refs[key] as any).classList.value = "input-error";
                } else if(this.$refs[key]) {
                    (this.$refs[key] as any).classList.value = "";
                }
            });
            this.errorMsg = "Please fill out all fields";
            if(!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                .test(data.email)) {
                    isError = true;
                    (this.$refs.email as any).classList.value = "input-error";
                    this.errorMsg = 'Must use a valid email';
            } else {
                (this.$refs.email as any).classList.value = "";
            }
            if(!(this.$refs.agree as any).checked){
                this.showErrorMsg = true;
                this.errorMsg = 'Must acknowledge this agreement by checking the box';
                isError = true;
            }
            if(isError){
                this.showErrorMsg = true;
                this.disableButton = false;
                return;
            }
            this.showErrorMsg = false;
            this.cardError = '';

            let clientSecret;
            await axios.post(this.$store.state.apiUrl + '/payment/setup-intent', data)
                .then(resp => {
                    clientSecret = resp.data.clientSecret;
                })
                .catch(e => {
                    alert(e.response ? e.response.data : 'There was an error.');
                    this.disableButton = false;
                });
            if(!clientSecret) return;

            // eslint-disable-next-line @typescript-eslint/camelcase
            const setupResult = await this.stripeInstance.confirmCardSetup(clientSecret, {
                // eslint-disable-next-line @typescript-eslint/camelcase
                payment_method: {
                    card: this.cardElement,
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    billing_details: {
                        name: `${data.firstName} ${data.lastName}`,
                        email: data.email,
                        address: {
                            line1: data.address,
                            city: data.city,
                            state: data.state,
                            // eslint-disable-next-line @typescript-eslint/camelcase
                            postal_code: data.zip
                        }
                    }
                }
            });
            if(setupResult.error) {
                this.cardError = setupResult.error.message;
                this.disableButton = false;
                return;
            }

            axios.post(this.$store.state.apiUrl + '/payment', { ...data, setupIntentId: setupResult.setupIntent.id })
                .then(async resp => {
                    if(resp.data && resp.data.requiresAction) {
                        const confirmResult = await this.stripeInstance.confirmCardPayment(resp.data.paymentIntentClientSecret);
                        if(confirmResult.error) {
                            alert(confirmResult.error.message);
                            this.disableButton = false;
                            return;
                        }
                    }
                    this.$store.state.tier = data.tier;
                    alert('Payment Updated Successfully!');
                    this.$router.push('/');
                    this.disableButton = false;
                })
                .catch(e => {
                    alert(e.response ? e.response.data : 'There was an error.');
                    this.disableButton = false;
                });
        },
        formatToPhone() {
            // Remove characters
            let newVal = this.phoneInput.replace(/[^0-9]/g, "");
            const input = newVal.replace(/\D/g,'').substring(0,10); // First ten digits of input only
            const zip = input.substring(0,3);
            const middle = input.substring(3,6);
            const last = input.substring(6,10);

            if(input.length > 6){newVal = zip+'-'+middle+'-'+last;}
            else if(input.length > 3){newVal = zip+'-'+middle;}
            else if(input.length > 0){newVal = zip;}
            this.phoneInput = newVal;
        },
        cancelDeleteCB() {
            this.showConfirmDelete = false;
        },
        confirmDeleteCB() {
            axios.delete(this.$store.state.apiUrl + '/payment')
                .then(() => {
                    // Reload so this view (and the rest of the app) picks up
                    // the now-canceled status and offers the tier cards again,
                    // rather than signing the user out entirely.
                    window.location.reload();
                })
                .catch(e => {
                    alert(e.response.data);
                    this.showConfirmDelete = false;
                })
        },
        switchTier(tier: number) {
            if(this.disableButton) return;
            this.disableButton = true;
            axios.post(this.$store.state.apiUrl + '/payment/changeplan', { tier })
                .then(() => {
                    this.$store.state.tier = tier;
                    alert('Plan Updated Successfully!');
                    this.disableButton = false;
                })
                .catch(e => {
                    alert(e.response ? e.response.data : 'There was an error.');
                    this.disableButton = false;
                });
        },
        toggleUpdateCard() {
            this.showUpdateCard = !this.showUpdateCard;
            if(this.showUpdateCard) {
                this.$nextTick(() => this.setupCardElement());
            }
        },
        loadInvoices() {
            this.invoicesLoading = true;
            this.invoicesError = false;
            axios.get(this.$store.state.apiUrl + '/payment/invoices')
                .then(resp => {
                    this.invoices = resp.data;
                    this.invoicesLoading = false;
                })
                .catch(e => {
                    console.log(e);
                    this.invoicesError = true;
                    this.invoicesLoading = false;
                });
        },
        formatInvoiceDate(unixSeconds: number): string {
            return new Date(unixSeconds * 1000).toLocaleDateString();
        },
        formatAmount(cents: number, currency: string): string {
            return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (currency || 'usd').toUpperCase() });
        },
        statusLabel(inv: any): string {
            if(inv.fullyRefunded) return 'Refunded';
            if(inv.refunded) return 'Partially Refunded';
            return inv.status;
        },
        statusClass(inv: any): string {
            return inv.refunded ? 'status-refunded' : 'status-' + inv.status;
        }
    }
})
